import { QUOTES_TYPE } from "@/common/const/types/index.const";
import { z } from "zod";

const addressDataSchema = z.object({
  lat: z.number(),
  long: z.number(),
  city: z.string(),
  state: z.string(),
  street: z.string(),
  country: z.string(),
  buildingNumber: z.string().min(1, "Pick valid address"),
  zipCode: z.string(),
});

const singleQuoteSchema = z.object({
  endCustomerName: z.string().min(1, "End Customer name is required"),
  customerProjectNumber: z.string().min(1, "Project name is required"),
  productType: z.enum(QUOTES_TYPE),
  startAddress: addressDataSchema,
  endAddress: addressDataSchema.optional(),
  companyId: z.number({ message: "Chose customer from list" }),
  userId: z.number(),
  RFSdate: z.string().optional(),
  dueDate: z.string().optional(),
  addressAValid: z.boolean(),
  addressBValid: z.boolean(),
});
type SingleQuoteDTO = z.infer<typeof singleQuoteSchema>;
export default singleQuoteSchema;
export type { SingleQuoteDTO };
